<template>
  <div class="zj-emergency-task-feedback-list select-none">
    <el-table :data="tableData" :show-header="false" stripe="false">
      <el-table-column>
        <template slot-scope="scope">
          <div class="task-row select-none">
            <div>
              <div>{{ scope.row.createdate }}</div>
              <div>{{ scope.row.createUser }}</div>
              <div :class="{islive:scope.row.feedbackType == 1 }">【{{ scope.row.feedbackTypeTranslated }}】</div>
            </div>
            <div>{{scope.row.content}}</div>
            <div v-if="scope.row.imgs">
              <div
                class="media-wrapper"
                v-for="(item, index) in scope.row.imgs.split(',')"
                :key="index"
              >
                <img v-bind:src="item" alt="图片链接无效" />
              </div>
            </div>
            <div v-if="scope.row.videos">
              <div
                class="media-wrapper"
                v-for="(item, index) in scope.row.videos.split(',')"
                :key="index"
              >
                <video controls style=" height: 8.1rem;width: 14.4rem;">
                  <source v-bind:src="item" type="video/mp4" />
                  <source v-bind:src="item" type="video/ogg" />Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import ZJApp from "../../../../../../app";
import { list } from "@/api/src/emergency_feedback";
export default {
  name: "ZJEmergencyComponentTaskFeedbackList",
  componentName: "ZJEmergencyComponentTaskFeedbackList",
  components: {},
  props: {
    ExecutId: {
      type: String,
      required: true
    },
    planId: {
      type: String,
      required: true
    },
    planName: {
      type: String,
      required: true,
      default: "备用应急预案"
    },
    query: {
      obj: String,
      type: String
    }
  },
  data() {
    return {
      activeName: "first",
      tableData: [],
      dateFormat: "MM-dd hh:mm",
      msgkey: {
        emergencyFeedbackKey: "MessageKey_EmergencyFeedBack" + this.ExecutId,
        startTaskMsgKey: "MessageKey_EmergencyEventStartTask",
      }
    };
  },
  created() {
    let arr = Object.keys(this.msgkey)
    arr.map(item =>{
      this.$notify.subscript(this.msgkey[item], x =>
        this.search()
      );
    })
    this.search();
  },
  methods: {
    search() {
      let that = this;
      console.log(that.ExecutId);
      list({ eventId: that.ExecutId, current: 1, size:999 })
        .then(r => {
          r = r.data.records;
          this.tableData = r;
        })
        .catch(e => {
        });
    },
    onEmergencyFeedbackReceived: function(msg) {
      var record = JSON.parse(msg.firstBlock().text);
      this.tableData.unshift(record);
    },
    // isImage: function(filename) {
    //   return ZJApp.ZJUtils.isImage(filename);
    // },
    // isVideo: function(filename) {
    //   return ZJApp.ZJUtils.isVideo(filename);
    // }
  },
  watch: {},
  destroyed() {
    this.$notify.unsubscript(this.msgkey.emergencyFeedbackKey);
    this.$notify.unsubscript(this.msgkey.startTaskMsgKey);
   }
};
</script>